export enum QualityMode {
  AUTO = 'auto',
  MANUAL = 'manual',
  UNAVAILABLE = 'unavailable',
}
